import assocIndexOf from "./component-library485.mjs";
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
export {
  listCacheHas as default
};
